import {gridExport} from '../project-review/all';

let gridData = [];
let gridColumns = [];
let $param = null;
let exportName = null;

export default function ($gridEle, sproc, paramString, forParam, fileName) {
    return new Promise((resolve, reject) => {
        $param = $(`#${forParam}`);
        exportName = fileName;
        createTempGrid($gridEle, sproc, paramString)
            .then(() => {
                createActualGrid($gridEle);
            })
            .finally(_ => {
                resolve();
            });
    });
}

const createTempGrid = ($actualGrid, sproc, paramString) => {
    return new Promise((resolve, reject) => {
        let $tempGrid = document.createElement('div');
        $tempGrid.id = 'tempGrid';

        $tempGrid = $($tempGrid);
        if ($tempGrid.length) {
            //Create DataSource
            let _dataSource = new kendo.data.DataSource({
                transport: {
                    create: {
                        url: `/Reporting/Ssrs/GetGridData?sproc=${sproc}&paramString=${paramString}`,
                        type: 'POST',
                        dataType: 'json'
                    }, read: {
                        url: `/Reporting/Ssrs/GetGridData?sproc=${sproc}&paramString=${paramString}`,
                        type: 'POST',
                        dataType: 'json'
                    }
                }, schema: {
                    data: function (data) {
                        let dataArray = [];
                        if (data.length > 0) {
                            let propertyArray = [];
                            //Get Properties from data
                            for (let property in data[0]) {
                                let locked = true;
                                if (property != null) {
                                    let tempObj = {};
                                    if (property === 'returned') {
                                        tempObj = {
                                            field: 'returned',
                                            title: ' ',
                                            hidden: false,
                                            template: kendo.template('<span data-returned="#=returned#" class="link cursor-pointer js-ssrs-select-grid-item">Select</span>'),
                                            width: '50px'
                                        };
                                    } else {
                                        tempObj = {
                                            field: property.replace(/\s|-/g, ''),
                                            title: property,
                                            hidden: false,
                                            minResizableWidth: 100,
                                            locked: !locked,
                                            // template: `<span>#=${property.replace(/\s|-/g, '')}#</span>`
                                        };
                                    }
                                    propertyArray.push(tempObj);
                                }
                            }

                            for (let item in data) {
                                let tempData = data[item];
                                for (let field in tempData) {
                                    let newKey = field.replace(/\s|-/g, '');
                                    if (field !== newKey) {
                                        Object.defineProperty(tempData, newKey, Object.getOwnPropertyDescriptor(tempData, field));
                                        delete tempData[field];
                                    }
                                }
                                dataArray.push(tempData);
                            }

                            gridColumns = propertyArray;
                            gridData = dataArray;
                        }
                        resolve();
                        return dataArray;
                    }
                }
            });

            //Create base grid Grid
            $tempGrid.kendoGrid({
                dataSource: _dataSource
            }).remove();
        }
    });
};

const createActualGrid = ($actualGrid) => {
    if ($actualGrid.length) {
        let dateTime = new Date(),
            fileName = `${exportName}_${dateTime.getFullYear()}${(dateTime.getMonth() + 1)}${dateTime.getDate()}.xlsx`,
            toolbarTemplate = null;
        if (exportName) {
            toolbarTemplate = kendo.template('<input id="export" style="float:right;" />');
        }
        $actualGrid.kendoGrid({
            columns: gridColumns, dataSource: {
                data: gridData, pageSize: 20
            }, resizable: true, toolbar: toolbarTemplate, excel: {
                fileName: fileName,
                proxyURL: 'https://demos.telerik.com/kendo-ui/service/export',
                filterable: true,
                allPages: true
            }, mobile: true, width: '100%', scrollable: true, sortable: {
                mode: 'multiple'
            }, filterable: true, /*groupable: true,*/
            dataBound: function (e) {
                for (let i = 0; i < this.columns.length; i++) {
                    this.autoFitColumn(i);
                }
                closeAndPopulateAnswer();
            }, pageable: {
                alwaysVisible: false, pageSizes: true, buttonCount: 5
            }
        });

        //Add Grid Export Functionality
        gridExport();
    }
};

const closeAndPopulateAnswer = () => {
    let $returnBtns = $('.js-ssrs-select-grid-item');

    if ($returnBtns.length) {
        $returnBtns.click(function () {
            let $self = $(this);

            $self.closest('.k-window-content').data('kendoWindow').close();
            let d_param = $param.data(),
                k_param = d_param.kendoAutoComplete,
                value = $(this).data('returned').toString().trim();

            if (k_param) {
                k_param.value(value);
            } else {
                $param.val(value);
            }
        });
    }
};